import { useAuthStore } from '@shared/stores/authStore';
import { useDocumentTitle } from '@shared/hooks/useDocumentTitle';
import { Navigate, Outlet, useMatch } from 'react-router-dom';

interface GuestGuardProps {
  redirectPath?: string;
}

const GuestGuard = ({ redirectPath = '/' }: GuestGuardProps): JSX.Element => {
  const token = useAuthStore((state) => state.token);
  const invitationRoute = useMatch('/invitation/accept');
  useDocumentTitle(); // Actualizar título del documento para rutas guest

  if (token && !invitationRoute) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default GuestGuard;
